
// region JS Imports

// region External Modules
import { EventEmitter } from "events"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports

/* eslint-disable no-unused-vars */
enum EventTypes {
  SUBSCRIBE   = "subscribe",
  UNSUBSCRIBE = "unsubscribe",
}
/* eslint-enable no-unused-vars */

interface SubscribeEventPayload {
  building_id: string | number,
  follow_type: string,
}
interface UnsubscribeEventPayload {
  building_id: string | number,
  follow_type: string,
}

class EventStore {
  private readonly event_emitter: EventEmitter

  constructor() {
    this.event_emitter = new EventEmitter()
  }

  public onSubscribe(cb: (payload: SubscribeEventPayload) => void) {
    this.event_emitter.on(EventTypes.SUBSCRIBE, cb)
  }
  public fireSubscribeEvent(payload: SubscribeEventPayload) {
    this.event_emitter.emit(EventTypes.SUBSCRIBE, payload)
  }

  public onUnsubscribe(cb: (payload: UnsubscribeEventPayload) => void) {
    this.event_emitter.on(EventTypes.UNSUBSCRIBE, cb)
  }
  public fireUnsubscribeEvent(payload: UnsubscribeEventPayload) {
    this.event_emitter.emit(EventTypes.UNSUBSCRIBE, payload)
  }
}

const instance = new EventStore()

export default instance
